import { AtlassianProductHostingTypeValues as HostingType, MarketplacePricingTierTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import React from 'react';
import { PerUserPricingTiersTable } from "../../PricingTable/PricingTable";
import { RemoteAgentTiersTable } from "../RemoteAgentPricing";
import { ServerDCTiersTable } from "../ServerDCPricing";

const PricingTable = props => {
  const {
    tierType,
    currency,
    items,
    hosting,
    billingCycle
  } = props;

  if (tierType === MarketplacePricingTierTypeValues.RemoteAgentTiered) {
    return /*#__PURE__*/React.createElement(RemoteAgentTiersTable, {
      items: items,
      currency: currency
    });
  } // other tiers => UserAgentTiered


  if (hosting === HostingType.Server || hosting === HostingType.DataCenter) {
    return /*#__PURE__*/React.createElement(ServerDCTiersTable, {
      items: items,
      currency: currency
    });
  }

  return /*#__PURE__*/React.createElement(PerUserPricingTiersTable, {
    items: items,
    currency: currency,
    billingCycle: billingCycle
  });
};

export default PricingTable;